import config from '../../config';
const baseURL   = config.BASE_URL;
const walletURL = config.WALLET_URL;

export const provider = {
  baseURL: baseURL,
  walletURL: walletURL,
  token:"/token",

  importTransactionOrder:"/import_transaction_order",
  importTransactionDN:"/import_transaction_delivery_note",
  importTransactionInvoice:"/import_transaction_invoice",
  importReceivePayment:"/import_transaction_payment",
  importTakeOut:"/import_transaction_take_out",

  getTransactionOrder:"/get_transaction_order",
  getTransactionDeliveryNote:"/get_transaction_delivery_note",
  getTransaction:"/get_transaction_invoice",
  getListFarmer:"/get_list_farmer",
  getListSupplier:"/get_list_supplier",
  fetchListCategoryOpt:"/list_category_for_stock",
  fetchCustomerTypeOpt:"/get_customer_type_opt",
  fetchProductTypeOpt:"/get_product_type_opt",
  fetchTransactionTypeOpt:"/get_transaction_type_opt",
  getCategory:"/get_category",
  getCurrency:"/get_currency",
  getListProduct:"/get_list_product",
  getListProductSetting:"/list_product",
  getListProductPackage:"/get_group_product",
  getListProductFarmer:"/get_list_product_farmer_eco",
  getListTransactionProductOrder:"/get_list_transaction_product_order",
  getListTransactionProductTakeOut:"/list_transaction_product_takeout",
  getDueTransactionPaymentTerm:"/get_due_transaction_payment_term",
  getDueTransferTransactionPaymentTerm:"/list_due_transaction_payment_term",
  getTransactionPayment:"/get_transaction_payment",
  getListWalletCustomerType:"/get_list_wallet_customer_type",
  fetchListBuyBackInvoice: '/list_buy_back_invoice',
  fetchListBuyBackReport: '/get_buy_back_report',
  fetchListCropPendingPayment: '/get_crop_pending_payment',
  fetchListCropPendingFeePayment: '/get_crop_pending_fees_payment',
  getListUnit:"/get_list_unit",
  getListIncentive:"/get_list_incentive",
  getListCategory:"/get_list_category",
  getCategoryAll: "/get_category_all",
  getContactPaymentTerm: "/get_list_payment_term",
  getBusinessSetting: "/get_list_business_setting",
  paymentMethod:["credit","cash"],
  fetchListContactOpt:"/list_client",
  getStockDetailReport:"/get_list_stock_in_out",
  getProvince:"/get_province",
  getDistrict:"/get_district",
  getCommune:"/get_commune",
  getVillage:"/get_village",
  getListClientByLocation:"/get_list_client_by_location",
  getListStockClientById:"/get_list_stock_client_by_id",
  reportPo:"/report-po",
  getStockEndingReport:"/get_list_client_stock",
  getStockSupplierEndingReport:"/get_list_supplier_stock",
  listSupplierTransferByUserType:"/list_supplier_transfer_by_user_type",
  getListStockBySupplierId:"/list_stock_supplier_by_id",
  acceptStockTransfer:"/accept_stock_transfer",
  getContactIdByToken:"/get_contact_id_by_token",
  getContactByToken:"/get_contact_by_token",
  getListProductByCategory: "/get_product_by_category",
  getListMiller: "/get_all_miller",
  getListMillerAndExporter: "/get_miller_and_exporter",
  getlistWalkinMember: "/get_list_walkin_member",
  getListCropTrader: "/get_all_crop_trader",
  getStockReconcileList:"/list_stock_reconcile_v2",
  getStockTransfer:"/list_stock_transfer",
  getProductRegistration:"/list_product_registration",
  listProductCheckInOut:"/list_product_check_in_out",
  listProductOutsideEco:"/get_list_product_outside_eco",
  getStockList:"/get_list_stock_client_by_id",
  getListTransactionPayment:"/get_list_transaction_payment",
  getListPaymentReport:"/list_payment_reports",
  fetchMemberList:"/list_member_products",
  fetchListRequestDrawdown: '/list_crop_request_drawdown',
  fetchListInvoiceFinanceRequestDrawdown: '/list_crop_invoice_finance_request_drawdown',
  fetchListCropCollectPlaning: '/list_crop_collect_planing',
  fetchListDraftInvoice: '/get_draft_invoice',
  fetchListInvoiceType: '/list_draft_invoice_type',
  fetchListFinalInvoiceType: '/list_final_invoice_type',
  fetchDetailDraftInvoice: '/details_draft_invoice',
  fetchWalletAccount: '/get_wallet_account_for_draft_invoice',
  fetchListBill: '/get_list_bill',
  fetchListInvoice: '/get_list_invoice',
  fetchListPaymentVourcher: '/get_list_bill_payment',
  fetchListReceiptVourcher: '/get_list_invoice_payment',
  fetchListRevolvingCredit: '/get_list_draw_down',
  fetchRevolvingCreditDetail: '/request_draw_down_detail',
  fetchDueInvoicePaymentDetail: '/due_invoice_payment_detail',
  checkCustomerDrawdownExist: '/check_customer_drawdown_exist',
  getBillDetail: '/get_bill_details',
  getInvoiceDetail: '/get_invoice_details',
  getPaymentDetail: '/get_payment_details',
  getListProductConfirm: '/get_list_product_for_confirm',
  getTransactionReconcileInvoice: '/get_transaction_reconcile_invoice',
  getListContactPersonal: '/get_list_contact_personal',
  getListContactPersonalTab: '/initialize_tab_detail_by_customer_type',
  getDetailContactPersonal: '/get_detail_contact_personal',
  getDetailContactCompany: '/get_detail_contact_companies',
  getDetailContactCareer: '/get_detail_contact_career',
  getDetailContactPhoneSkill: '/get_detail_contact_phone_skill',
  getDetailContactExperience: '/get_detail_contact_experience',
  getDetailFileContactDocument: '/get_detail_file_contact_document',
  getProductPaddy: '/list_paddy_product',
  getPaddyGraph: '/get_paddy_graph',
  getPaymentReport: '/payment_report',
  getSaleTransaction: '/sale_transaction',
  getStockBalance: '/stock_balance',

  
  storeTransactionDeliveryNote:"/store_transaction_delivery_note",
  storeTransactionOrder:"/store_transaction_order",
  storeTransaction:"/store_transaction_invoice",
  storeTransactionProductTakeOut:"/store_transaction_product_takeout",
  storePaymentTerm:"/store_payment_term",
  storeCropPayment:"/store_crop_payment",
  reviewRequestDrawdown:"/review_request_drawdown",
  storeCropFeePayment:"/store_crop_fees_payment",
  storeBuyBackInvoice:"/store_buy_back_invoice",
  storeUnit: "/add_unit",
  storeIncentive: "/add_incentive",
  storeCategory:"/add_category",
  storeContactPaymentTerm: "/add_payment_term",
  storeTransferPaymentTerm: "/store_transaction_payment",
  storeProduct:"/add_product",
  storeBusinessSetting: "/add_business_setting",
  storeStockReconcile:"/store_stock_reconcile",
  storeStockReconcileV2:"/store_stock_reconcile_v2",
  storeStockTransfer:"/store_stock_transfer",
  storeProductRegistration:"/store_product_registration",
  storeProductCheckin:"/store_product_checkin",
  storeProductCheckout:"/store_product_checkout",
  storePaymentTransaction: "/store_payment_transaction",
  storeProductSetting: "/store_product",
  uploadMultiple: "/upload_image_product_registration",
  storeImageProductRegistration: "/store_image_product_registration",
  reviewCropRequestDrawdown: "/review_crop_request_drawdown",
  rejectCropRequestDrawdown: "/reject_crop_request_drawdown",
  reviewInvoiceFinanceRequestDrawdown: "/review_invoice_finance_request_drawdown",
  rejectInvoiceFinanceRequestDrawdown: "/reject_invoice_finance_request_drawdown",
  storeDraftInvoice: "/store_draft_invoice",
  storeFinalInvoice: "/store_final_invoice",
  storeInvoicePayment: "/store_invoice_payment",
  uploadDocumentReconcile: "/upload_document_reconcile",
  storePaymentTransactionReconcile: "/store_payment_transaction_reconcile",
  approvalMembership: "/approval_membership",
  updatePaymentMethod: "/update_payment_method",


  removeTransactionDeliveryNote:"/remove_transaction_delivery_note",
  removeTransactionOrder:"/remove_transaction_order",
  destroyUnit: "/delete_unit",
  destroyCropTransaction: '/remove_crop_transaction',
  destroyIncentive: "/delete_incentive",
  destroyCategory: "/delete_category",
  destroyContactPaymentTerm: "/delete_payment_term",
  destroyProduct:"/delete_product",
};
